import React, { Component, useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import { UserInfo, netGet, netPost, netFetch, keycloak } from "../network";
import { Typography } from "@mui/material";


function EffectivityChooser (props) {
    const {
        rootLabel=null,
        namespace,
        onSelectedItemsChange,
        onModelChange,
        ...other
    } = props;

    const [model, setModel] = useState([]);
    const [selectedItems, setSelectedItems] = React.useState([]);

  

    useEffect(() => {
        setSelectedItems([]);
        if ( Array.isArray(namespace)) {

        } else if ( namespace) {
            netGet('/api/eff/tree?ns=' + encodeURIComponent(namespace))
                .then(response => response.json())
                .then(etree => {
                    if (Array.isArray(etree)) {
                        setModel(etree);
                        if ( typeof onModelChange === 'function') {
                            onModelChange(etree);
                        }
                    }
                }).catch(error => {
                    console.log('Error fetching Effectivity tree: ' + error);
                });
        }

    },[namespace]);

    const handleSelectedItemsChange = (event, ids) => {
        setSelectedItems(ids);
        if ( typeof onSelectedItemsChange === 'function') {
            onSelectedItemsChange(event, ids);
        }
    };

    const displayNode = (item) => {
        return (<TreeItem itemId={item.id} label={item.name}>
            {Array.isArray(item.children) && item.children.length > 0 &&
                item.children.map(child => displayNode(child))
            }
        </TreeItem>);
    };

    return (
        <Box sx={{height: '100%'}}>
            {rootLabel && <Typography sx={{fontSize: '110%', fontWeight: 'bold'}}>{rootLabel}</Typography>}
            <SimpleTreeView 
                selectedItems={selectedItems}
                onSelectedItemsChange={handleSelectedItemsChange}
                expansionTrigger="iconContainer"
                multiSelect >
                {Array.isArray(model) && model.length > 0 && 
                    model.map( item => displayNode(item))
                }
            </SimpleTreeView>
        </Box>
    );
}





export {EffectivityChooser};